//
import { handleActions } from 'redux-actions';

import * as actions from './actions';

import { mkStdForm, mkStdFormsStore } from './types';

const reducer = handleActions(
  {
    [actions.stdFormAdd]: (state, { payload }) => {
      const { id, type = 'StdForm' } = payload;
      return state.setIn(['stdFormsById', id], mkStdForm({ id, type }));
    },

    [actions.stdFormDelete]: (state, { payload: id }) => state.deleteIn(['stdFormsById', id]),

    [actions.stdFormCancelled]: (state, { payload: id }) => state.setIn(['stdFormsById', id, 'cancelled'], true),

    [actions.stdFormSubmitted]: (state, { payload: id }) =>
      state.mergeIn(['stdFormsById', id], {
        submitCancelled: false,
        submitSucceeded: false,
        submitFailed: false,
        submitResponseData: null,
      }),

    [actions.stdFormSubmitSuccess]: (state, { payload: { id, data } }) =>
      state.mergeIn(['stdFormsById', id], {
        submitSucceeded: true,
        submitResponseData: data,
      }),

    [actions.stdFormSubmitFailure]: (state, { payload: { id, data } }) =>
      state.mergeIn(['stdFormsById', id], {
        submitFailed: true,
        submitResponseData: data,
      }),
  },
  mkStdFormsStore(),
);

export const REDUCER_KEY = 'stdFormsStore';
export default reducer;
